var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-card-v2", {
    attrs: {
      "one-log": _vm.oneLog,
      linkedtype: _vm.linkedtype,
      linkedid: _vm.linkedid,
      "has-history": false
    },
    scopedSlots: _vm._u([
      {
        key: "label",
        fn: function() {
          return [
            _c("person-list-light", {
              attrs: {
                list: [_vm.contact],
                placeholder: _vm.oneLog.staffs.params.placeholder
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "icon",
        fn: function() {
          return [
            _c("CompassObject", {
              attrs: { object: "tracking", size: "small" }
            })
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "flex-column flex-top mt-2 hp-10 lh-20 fs-3" },
              [
                _vm.isForm
                  ? [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$l10n.__("A soumis le formulaire:")) +
                            "\n                    "
                        ),
                        _c("span", { staticClass: "semibold" }, [
                          _vm._v(
                            _vm._s(_vm.tracking.form_id) +
                              " - " +
                              _vm._s(_vm.tracking.form_name)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$l10n.__("Depuis:")) +
                            "\n                    "
                        ),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.tracking.url, target: "_blank" }
                          },
                          [_vm._v(_vm._s(_vm.tracking.url))]
                        )
                      ])
                    ]
                  : _c("p", { staticClass: "m-0 wp-9 ellipsis" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$l10n.__("A visité:")) +
                          "\n                "
                      ),
                      _c(
                        "a",
                        { attrs: { href: _vm.tracking.url, target: "_blank" } },
                        [_vm._v(_vm._s(_vm.tracking.url))]
                      )
                    ])
              ],
              2
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }